import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

import FrameworkLogo from '../../assets/img/landingPage/AVAP_Framework.svg';
import avapLogo from '../../assets/img/logos/AVAP_Lenguaje_white.svg';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';
import icn_mision from '../../assets/img/landingPage/about/aboutUs_mision.svg';
import icn_vision2 from '../../assets/img/landingPage/about/aboutUs_vision.png';
import icn_mision2 from '../../assets/img/landingPage/about/aboutUs_mision.png';


import openAi from '../../assets/img/landingPage/openapi-blanco.png'
import linux from '../../assets/img/landingPage/Linux.png'
import fondo from '../../assets/img/landingPage/fondo.png';
import logo200 from '../../assets/img/landingPage/twelveHundred_inversionistas-w.png';
import ReactGA from 'react-ga4'

import AvapPicture from '../../assets/img/landingPage/AboutUs-01.png';

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

const Support = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);


    return (
        <>
            <FlNav></FlNav>
            <div id="pricing" className="fl-framework bg-black text-white" style={{ backgroundImage: `url(${fondo})` }}>
                {/* Hero Section */}
                <section id="heroPlaton" className="text-center pt-0 pb-0" >
                    {/*<img className="logo img-fluid" src={FrameworkLogo} alt="Logo AVAPFramework"/>*/}
                    <h1 className="fl-title-big mb-2">Need Support?</h1>
                    <p className="fl-title gradient-text mb-5 fl-txt-container-s">We’re here to help you through the right channel for you. </p>
                    <p className="fl-subtitle mb-4">Are you an End User?</p>
                    <p className="fl-text m-0 fl-txt-container pb-6">AVAP’s customer support is provided exclusively through our trusted partners.
                    If you’re using a solution built with AVAP, please reach out directly to your provider for assistance.</p>
                    {/* <img
                        src="https://placehold.co/600x300"
                        alt="Placeholder"
                        className="img-fluid mt-4"
                    /> */}
                    
                </section>

                {/* AVAP PArtner */}
                <section className="container py-5 fl-gradientContainer mb-5" >
                    <div className="row">
                        <div className="col-md-12 pl-5 text-center">
                            {/* <img
                                src={icn_vision2}
                                alt="Icon representing vision."
                                className="mb-3 aboutIcon"
                            
                            />*/}
                            <h3 className="fl-subtitle mb-4">Are you an AVAP Partner?</h3>
                            <p className="fl-text justify-content-center">
                                You have access to dedicated support and consulting services through AVAP Connect, our partner platform.
                             <ul className=" text-center">
                                <li className="fl-bullets">Get help with technical issues</li>
                                <li className="fl-bullets">Access documentation and resources</li>
                                <li className="fl-bullets">Request expert consulting</li>
                            </ul>

                            </p>       
                            {/*Boton Login Connect*/}  
                              <a className="glowBtn-dark " style={{zIndex: 2}} href="https://101obex.my.site.com/avapconnect/login" target='_blank'><span className="btnInner">Log in to AVAP Connect </span></a>                  
                        </div>
                    </div>
                </section>



                
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default Support;
